import React, { useState, useEffect } from 'react';
import { CardBody, Row, Col, Button, UncontrolledTooltip } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';
import DataReactTable from './DataReactTable';
import ReactTableActions from './ReactTableActions';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import FormPatient from '../../CreatePatient/components/FormPatient';
import Modal from '@material-ui/core/Modal';

const PatientList = () => {
    const user = JSON.parse(sessionStorage.getItem('usuario'));
    const userPermits = user.hasOwnProperty('perfil') ? user.perfil.hasOwnProperty('modulos') ? user.perfil.modulos : [] : [];
    const [patientsList, setPatientsList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [idSearchPatient, setIdSearchPatient] = useState('');
    const [errors, setErrors] = useState({});
    const [onUpdate, setOnUpdate] = useState(false);
    const [patientToUpdate, setPatientToUpdate] = useState(null);
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [openModalCreatePatient, setOpenModalCreatePatient] = useState(false);

    const validate = (values) => {
        const errors = {};
        if (!values.idSearchPatient) {
            errors.idSearchPatient = 'El campo no debe estar vacio';
        }

        return errors;
    };

    const updatePatientData = (patient) => {
        setPatientToUpdate(patient);
        setOnUpdate(true);
        setOpenModalCreatePatient(true);
    }

    const validateAllFields = (data) => {
        if (
            (idSearchPatient == undefined || idSearchPatient == null || idSearchPatient == 0 || idSearchPatient == "0" || idSearchPatient == "") && //num_documento
            (name == undefined || name == null || name == 0 || name == "0" || name == "") && //nombres
            (lastName == undefined || lastName == null || lastName == 0 || lastName == "0" || lastName == "") //apellido1
        ) {
            return false;
        }
        else {
            return true;
        }
    }

    const loadPatient = () => {
        setIsLoading(true);
        fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                //console.log(data);               

                filterData(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const loadSearchPatient = () => {
        let dataSend = {
            num_documento: parseInt(idSearchPatient),
            nombres: name,
            apellido1: lastName
        }

        console.log(dataSend)
        let validate = validateAllFields();

        console.log("STATEVALIDATE", validate)
        if (!validate) {
            alert("Debe especificar como minimo un parametro de busqueda");
            return;
        }
        setIsLoading(true);

        fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.existe) {
                    filterData(data)
                } else {
                    setPatientsList([]);
                    alert("No hay ningún paciente con el parámetro de busqueda ingresado");
                }

                //filterData(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const filterData = (data) => {
        let orderData = [];
        console.log(data.contenido);
        for (let i = 0; i < data.contenido.length; i++) {
            orderData[i] = {
                id: data.contenido[i].id_paciente,
                tip_documento: data.contenido[i].tip_documento,
                num: data.contenido[i].num_documento,
                fullname: data.contenido[i].apellido2 != null ? data.contenido[i].nombres + " " + data.contenido[i].apellido1 + " " + data.contenido[i].apellido2 : data.contenido[i].nombres + " " + data.contenido[i].apellido1,
                correo: data.contenido[i].correo,
            };
        }
        console.log("DATAORGANIZED", orderData);
        setPatientsList(orderData);
    }

    const reactTableData = {
        tableHeaderData: [{
            Header: 'TIP. DOC.',
            accessor: 'tip_documento',
            disableGlobalFilter: true,
            width: 65,
        },
        {
            Header: 'DOCUMENTO',
            accessor: 'num',
        },
        {
            Header: 'NOMBRE',
            accessor: 'fullname',
        },
        {
            Header: 'CORREO',
            accessor: 'correo',
        },
        ],
        tableRowsData: patientsList
    };


    return (
        <CardBody>
            <Col>
                <Row>
                    <Col md={12}>
                        <h5 style={{ color: '#757575' }}>
                            Ingrese un parámetro de busqueda
                        </h5>
                        <br />
                    </Col>
                </Row>
                <form className="material-form" >
                    <Row>
                        <Col md={3}>
                            <TextField
                                required
                                id="document-standard-required"
                                label="Documento"
                                className="material-form__field"
                                type="number"
                                value={idSearchPatient}
                                onChange={(e) => {
                                    setIdSearchPatient(e.target.value);
                                }}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        loadSearchPatient();
                                    }
                                }}
                            />
                        </Col>
                        <Col md={3}>
                            <TextField
                                required
                                id="name-standard-required"
                                label="Nombre"
                                className="material-form__field"
                                type="text"
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value);
                                }}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        loadSearchPatient();
                                    }
                                }}
                            />
                        </Col>
                        <Col md={3}>
                            <TextField
                                required
                                id="lastName-standard-required"
                                label="Primer apellido"
                                className="material-form__field"
                                type="text"
                                value={lastName}
                                onChange={(e) => {
                                    setLastName(e.target.value);
                                }}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        loadSearchPatient();
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                    <div className='flex-spac-bet-elem'>
                        {userPermits.includes(10) &&
                            <div>
                                <Button
                                    color="primary"
                                    size="sm"
                                    id="searchBtn"
                                    onClick={() => {
                                        setOpenModalCreatePatient(true)
                                    }}
                                >
                                    Crear Paciente
                                </Button>
                            </div>
                        }
                        <div>
                            <Button
                                style={{ marginLeft: 10, marginTop: 10 }}
                                color="primary"
                                size="sm"
                                id="searchBtn"
                                onClick={() => {
                                    loadSearchPatient();
                                }}
                            >
                                Buscar
                            </Button>
                        </div>

                    </div>
                </form>
            </Col>
            {isLoading ?
                <div className="text-center">
                    {/* <Spinner animation="border" variant="success" /> */}
                </div>
                :
                <DataReactTable
                    title={''}
                    refresh={loadPatient}
                    reactTableData={reactTableData}
                    ReactTableActions={ReactTableActions}
                    callbackUpdate={updatePatientData}
                />
            }
            {openModalCreatePatient &&
                <Modal
                    open={openModalCreatePatient}
                    onClose={e => {
                        setOpenModalCreatePatient(false)
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                            <FormPatient setOpenModalCreatePatient={setOpenModalCreatePatient} onUpdate={onUpdate} patientToUpdat={patientToUpdate} />
                        </div>
                    </div>
                </Modal>
            }
        </CardBody>
    );

}

export default PatientList;